import Component from '~/components/component';
import MapManager, {MANAGE_MAP_EVENT} from '../../helpers/map-manager';

export default class Mapbox extends Component {
    constructor(...args) {
        super(...args);

        this._map = new MapManager( {
            dataMap : {
                container : this._find('.js-map'),
                accessToken : 'pk.eyJ1Ijoic3dlZXRwdW5rZGV2IiwiYSI6ImNqeHltYWY5YTAyOW8zb3FwaGg2ZWFzdDEifQ.tmGJA7NCK-WDdfO7wZVjwg',
                style : 'mapbox://styles/sweetpunkdev/cjz8k09he0ceq1cna2smuvrcj',
                zoom : ( ENV.device == 'mobile' ) ? 3 : 4,
                minZoom: 1,
                navigationCustom : {
                  'zoom' : document.body.querySelector('.js-zoom-in'),
                  'unzoom' : document.body.querySelector('.js-zoom-out')
                },
                scrollZoom: false,
                center: ( ENV.device == 'mobile' ) ? [ 2.3488 , 48.8534 ] : [ -7.9236327 , 45.4390627 ],
                disableDragRotation: true
            },
            dataClusters: {
                list : [
                    {
                        id: 'cinema-technologies',
                        markers: dataCinemasTechnologies,
                        clusterMaxZoom : 50,
                        clusterRadius: 30,
                        clusterCircle: {
                            color: '#eba608',
                            stroke: {
                                width: 8,
                                color: '#ffc426',
                            },
                            radius: [
                                "step",
                                ["get", "point_count"],
                                20,
                                100,
                                30,
                                750,
                                40
                            ]
                        },
                        clusterCount: {
                            size: 12
                        },
                        clusterPoint: {
                            pinImage : MEDIAS + '/images/pin-cinema-technologies.png',
                            size: 1
                        }
                    },
                    {
                        id: 'cinema-no-technologies',
                        markers: dataCinemasNoTechnologies,
                        clusterMaxZoom : 50,
                        clusterRadius: 30,
                        clusterCircle: {
                            color: '#808487',
                            stroke: {
                                width: 8,
                                color: '#a1a4a7',
                            },
                            radius: [
                                "step",
                                ["get", "point_count"],
                                20,
                                100,
                                30,
                                750,
                                40
                            ]
                        },
                        clusterCount: {
                            size: 12
                        },
                        clusterPoint: {
                            pinImage : MEDIAS + '/images/pin-cinema-no-technologies.png',
                            size: 1
                        }
                    }
                ]
            }
        } );
    }

    _retrieveDOM() {
    }

    _update( pos ) {
    }

    show() {
        super.show();
    }

    bind() {
        super.bind();

        this._listerners = {};

        if( this._map ) {
            this._map.on( MANAGE_MAP_EVENT.CLICK_PIN, () => {
                this.emit( MANAGE_MAP_EVENT.CLICK_PIN );
            } )

            this._map.on( MANAGE_MAP_EVENT.CLOSE_POPUP, () => {
                this.emit( MANAGE_MAP_EVENT.CLOSE_POPUP );
            } )
        }
    }

    /*
    init() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/mapbox/mapbox.js